import { inject, InjectionToken } from '@angular/core';
import { I18nFacade } from './i18n-facade';
import { NgxI18nFacadeService } from './ngx-i18n-facade.service';

export const I18N_FACADE = new InjectionToken<I18nFacade>('I18N_FACADE', {
  providedIn: 'root',
  factory: () => inject(NgxI18nFacadeService),
});
